import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import {
    dataBodyTemplate,
    colorTemplate
} from './templateCadastro';

const PopupCpf = props => {
    const { objFinal } = props;

    return (

        <DataTable scrollable={true} scrollHeight="280px" value={objFinal} stripedRows>
            <Column field="Nome" header="Nome"/>

            <Column field="Inscricao" header="Inscrição"/>

            <Column field="Data" body={dataBodyTemplate} header="Data"/>

            <Column field="descSubGrupo" header="Plano"/>

            <Column field="Grupo" header="Status"/>

            <Column field="Motivo" header="Motivo Cancelamento" />

            <Column field="Inadimplencia" header="Inadimplência" body={colorTemplate} />
        </DataTable>

    );
};

export default PopupCpf;
